import React, { useEffect, useState } from 'react'
import './AddTenant.scss'
import { Form, Button, Table, Modal } from "react-bootstrap";
import { toast } from 'react-toastify';
import loaderImageGif from "../../assets/img/kodi_loader.gif";


// auth imports
import { useParams } from "react-router-dom";
import { serverUrl } from "../../serverUrl";
import { useNavigate } from 'react-router'

function AddTenant() {
  const { id, housetenant } = useParams();
  const occupiedHouseMessage = "This house already has an active tenant. Remove the current tenant from the selected unit page first, then add the new tenant.";
  // loading status
  const [isLoading, setIsLoading] = useState(true)
  const [tenantLength, setTenantLength] = useState(0)
  const [tenants, setTenant] = useState({})
  const [tenantsTable, setTenantTable] = useState()
  const [showModal, setShowModal] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [isSubmittingNewTenant, setIsSubmittingNewTenant] = useState(false);
  const [isSubmittingExistingTenant, setIsSubmittingExistingTenant] = useState(false);
  const navigate = useNavigate();

  const normalizePhone = (value) => (value || "").replace(/[^0-9]/g, "");
  const getApiErrorMessage = (error, fallback = "Request failed.") =>
    error?.response?.data?.error ||
    error?.response?.data?.data?.error ||
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    fallback;
  const createActiveOccupancyError = () => {
    const error = new Error("active_tenant_exists");
    error.userMessage = occupiedHouseMessage;
    return error;
  };

  const buildPhoneVariants = (value) => {
    const digits = normalizePhone(value);
    if (!digits) {
      return [];
    }
    const variants = new Set([digits]);
    if (digits.startsWith("0") && digits.length >= 10) {
      variants.add(`254${digits.slice(1)}`);
      variants.add(digits.slice(1));
    } else if (digits.startsWith("254") && digits.length >= 12) {
      const rest = digits.slice(3);
      variants.add(`0${rest}`);
      variants.add(rest);
    } else if (digits.length === 9) {
      variants.add(`0${digits}`);
      variants.add(`254${digits}`);
    }
    Array.from(variants).forEach((variant) => {
      if (variant.startsWith("254")) {
        variants.add(`+${variant}`);
      }
    });
    return Array.from(variants);
  };


  // get the tenants of that apartment
  const accessToken = localStorage.getItem("authTokens");
  // get the access token
  const parsedTokens = JSON.parse(accessToken);
  const access = parsedTokens.access;

  useEffect(() => {
    const requestConfig = {
      headers: { Authorization: `Bearer ${access}` }
    };
    setIsLoading(true);
    serverUrl.get(`/tenant/pending-tenant/?apartment_id=${id}`, requestConfig)
      .then((res) => {
        setTenantLength(res.data.count);
        setTenantTable(res.data.results);

        Promise.all(res.data.results.map((Tenant) =>
          serverUrl.get(`/users/users-details/?id=${Tenant.user}`, requestConfig)
            .then((response) => {
              const tenantData = {
                id: Tenant.id,
                fullName: response.data.results[0].full_name,
                phoneNumber: response.data.results[0].phone_number,
                user: Tenant.user,
              };

              setTenant((prevTenant) => ({
                ...prevTenant,
                [response.data.results[0].id]: tenantData,
              }));
            })
        )).then(() => {
          setIsLoading(false);
        });

      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, [access, id]);

  // add tenant modal 
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewTenantDateIn(null);
    setIsSubmittingNewTenant(false);
  };
  // form data for tenant details
  const [formDataTenant, setFormDataTenant] = useState({
    full_name: "",
    phone_number: ""
  });
  const [newTenantDateIn, setNewTenantDateIn] = useState(null);

  // done button reloading the page
  const handleCloseModalReload = () => {
    setShowModal(false);
    window.location.reload()
  };
  // counting the number of digits inserted on the phone number
  const digitCount = normalizePhone(formDataTenant.phone_number).length;


  // onchange functionality on adding tenant
  const handleChangeTenant = (event) => {
    const { name, value } = event.target;
    // limit phone number input to 10 digits
    if (name === "phone_number") {
      const digitOnly = normalizePhone(value);
      const maxLen = digitOnly.startsWith("254") ? 12 : 10;
      setFormDataTenant((prevFormData) => ({
        ...prevFormData,
        [name]: digitOnly.substring(0, maxLen),
      }));
    } else {
      setFormDataTenant((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  }
  // add the tenant to  database in the pending table 
  function handleSubmitTenanat(e) {
    e.preventDefault();
    if (isSubmittingNewTenant) {
      return;
    }
    // get user details so that you can use it from the access tokens
    const accessToken = localStorage.getItem("authTokens");

    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;

    // header's access token
    const config = {
      headers: { Authorization: `Bearer ${access}` }
    }

    if (!newTenantDateIn) {
      toast.error("Please select the tenant start date.");
      return;
    }

    const normalizedPhone = normalizePhone(formDataTenant.phone_number);
    const phoneVariants = buildPhoneVariants(normalizedPhone);
    if (!normalizedPhone) {
      toast.error("Please enter a valid phone number.");
      return;
    }
    setIsSubmittingNewTenant(true);

    const dataTenant = {
      email: `${normalizedPhone}@gmail.com`,
      full_name: formDataTenant.full_name,
      phone_number: normalizedPhone,
      password: normalizedPhone,
    };

    const fetchExistingUserId = () => {
      if (!phoneVariants.length) {
        throw new Error("existing_user_not_found");
      }
      const requests = phoneVariants.map((phone) =>
        serverUrl.get(`/users/users-details/?phone_number=${encodeURIComponent(phone)}`, config)
      );
      return Promise.allSettled(requests).then((results) => {
        for (const result of results) {
          if (result.status === "fulfilled") {
            const existingUser = result.value?.data?.results?.[0];
            if (existingUser?.id) {
              return existingUser.id;
            }
          }
        }
        throw new Error("existing_user_not_found");
      });
    };

    const getOrCreateUser = () => {
      return serverUrl
        .post(`/users/register/`, dataTenant)
        .then((res) => res.data?.data?.id)
        .then((id) => {
          if (id) {
            return id;
          }
          return fetchExistingUserId();
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            return fetchExistingUserId();
          }
          return fetchExistingUserId().catch(() => {
            throw error;
          });
        });
    };

    const getOrCreateTenant = (userId) => {
      return serverUrl
        .get(`/tenant/tenant/?user_id=${userId}`, config)
        .then((res) => {
          const existingTenant = res.data.results?.[0];
          if (existingTenant?.id) {
            return existingTenant.id;
          }
          return serverUrl.post(`/tenant/tenant/`, { user: userId }, config).then((createRes) => createRes.data.id);
        });
    };

    serverUrl.get(`/tenant/occupancy/?house_id=${housetenant}`, config)
      .then((res) => {
        const hasActiveTenant = res.data.results?.some((tenant) => tenant.status === 'active');
        if (hasActiveTenant) {
          throw createActiveOccupancyError();
        }
        return getOrCreateUser();
      })
      .then((userId) => getOrCreateTenant(userId))
      .then((tenantId) => {
        const tenantHouse = {
          status: "active",
          tenant: tenantId,
          house: housetenant,
          date_in: newTenantDateIn,
        };
        return serverUrl.post(`/tenant/occupancy/`, tenantHouse, config);
      })
      .then(() => {
        toast.success("Tenant Successfully Added to House.");
        setFormDataTenant({
          full_name: "",
          phone_number: ""
        });
        setNewTenantDateIn(null);
        navigate(`/selected-house/${housetenant}`);
      })
      .catch((error) => {
        if (error?.message === "active_tenant_exists") {
          toast.error(error.userMessage || occupiedHouseMessage);
          return;
        }
        if (error?.message === "existing_user_not_found") {
          toast.error("User already exists, but could not be fetched.");
          return;
        }
        if (error.response && error.response.status === 400) {
          toast.error(getApiErrorMessage(error));
        } else {
          toast.error("Unexpected error");
        }
        console.log(error);
      })
      .finally(() => {
        setIsSubmittingNewTenant(false);
      });

  }

  // passsing the id of the tenant to the modal
  const [showModalSaveTenant, setShowModalSaveTenant] = useState(false);

  const handleOpenSaveTenant = tenant => {
    setSelectedTenant(tenant);
    setTenantDateIn(null);
    setShowModalSaveTenant(true);
  };
  const handleCloseModalSaveTenant = () => {
    setShowModalSaveTenant(false);
    setTenantDateIn(null);
    setIsSubmittingExistingTenant(false);
  };
  // add the tenant to database as a tenant

  const [tenantDateIn, setTenantDateIn] = useState(null)

  const handleAddTenanat = () => {
    if (isSubmittingExistingTenant) {
      return;
    }
    if (!tenantDateIn) {
      toast.error("Please select the tenant start date.");
      return;
    }
    if (!selectedTenant?.user) {
      toast.error("Select a tenant first.");
      return;
    }
    setIsSubmittingExistingTenant(true);

    const accessToken = localStorage.getItem("authTokens");
    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;


    // headers access token
    const config = {
      headers: { Authorization: `Bearer ${access}` }
    }
    const idTenant = selectedTenant.user

    const data = {
      user: idTenant
    }

    const getOrCreateTenant = () => {
      return serverUrl
        .get(`/tenant/tenant/?user_id=${idTenant}`, config)
        .then((res) => {
          const existingTenant = res.data.results?.[0];
          if (existingTenant?.id) {
            return existingTenant.id;
          }
          return serverUrl.post(`/tenant/tenant/`, data, config).then((createRes) => createRes.data.id);
        });
    };
    serverUrl.get(`/tenant/occupancy/?house_id=${housetenant}`, config)
      .then((res) => {
        const hasActiveTenant = res.data.results?.some((tenant) => tenant.status === 'active');
        if (hasActiveTenant) {
          throw createActiveOccupancyError();
        }
        return getOrCreateTenant();
      })
      .then((tenantId) => {
        const tenantHouse = {
          status: "active",
          tenant: tenantId,
          house: housetenant,
          date_in: tenantDateIn,
        };
        return serverUrl.post(`/tenant/occupancy/`, tenantHouse, config);
      })
      .catch((error) => {
        if (error?.message === "active_tenant_exists") {
          toast.error(error.userMessage || occupiedHouseMessage);
          return;
        }
        if (error.response && error.response.status === 400) {
          toast.error(getApiErrorMessage(error));
        } else {
          toast.error("Unexpected error");
        }
        console.log(error)
      })
      .then((response) => {
        if (!response) {
          return;
        }
        toast.success("Tenant Successfully Added to House.");
        setTenantDateIn(null);
        setShowModalSaveTenant(false);
        navigate(`/selected-house/${housetenant}`);
      })
      .finally(() => {
        setIsSubmittingExistingTenant(false);
      });

  };


  // delete tenant from our database
  const [showModalDeleteTenant, setShowModalDeleteTenant] = useState(false);

  const handleOpenDeleteTenant = tenant => {
    setSelectedTenant(tenant);
    setShowModalDeleteTenant(true);
  };
  const handleCloseModalDeleteTenant = () => {
    setShowModalDeleteTenant(false);
  };
  const handleCloseModalReloadTenantDelete = () => {
    setShowModalDeleteTenant(false);
    window.location.reload()
  };

  const handleDeleteTenanat = () => {

    const accessToken = localStorage.getItem("authTokens");
    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;


    // headers access token
    const config = {
      headers: { Authorization: `Bearer ${access}` }
    }
    const idTenant = selectedTenant.user
    try {
      serverUrl
        //send the tenant details using the following endpoint
        .delete(`/users/users-details/${idTenant}/`, config)
        .then((res) => {
          toast.success("Tenant Sucessfully Deleted")
          handleCloseModalReloadTenantDelete()
        })
        // displaying the messages of why the error 
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.data.error);
          } else {
            console.log(error)
            toast.error('Unexpected error')
            console.log('Unexpected error: ' + error.message);
          }
        });

    } catch (error) {
      console.log(error);
      setIsLoading(false)
    }


  };
  // if the data is loading show a message
  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <img src={loaderImageGif} alt="Loading..." style={{ width: "400px" }} />

      </div>
    );
  }
  return (

    <div className='addTenant'>

      {tenantLength === 0 ?
        <>
          <div className='d-flex justify-content-between'>
            <p></p>
            <h2>Add Tenant</h2>

            <Button className='btn btn-PRIMARY border-0 text-white' onClick={handleOpenModal}>Add Tenant</Button>
            {/* modal for adding a new tenant */}
            <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Add Tenant</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <>
                  <Form onSubmit={handleSubmitTenanat}>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        className="input-field"
                        type="text"
                        name="full_name"
                        value={formDataTenant.full_name}
                        onChange={handleChangeTenant}
                        placeholder={"Tenant Name"}
                        required
                      />
                    </div>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        className="input-field"
                        type="number"
                        name="phone_number"
                        value={formDataTenant.phone_number}
                        onChange={handleChangeTenant}
                        placeholder={"Tenant Phone Number"}
                        required
                      />
                    </div>
                    <div className="tenant-date-label mt-3">Tenant Date In</div>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        type="date"
                        className="input-field"
                        value={newTenantDateIn || ""}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => setNewTenantDateIn(e.target.value)}
                        required
                      />
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        paddingRight: "20px",
                        float: "right",
                      }}
                    >
                      {digitCount}/10
                    </p>
                    <Button variant="primary" type="submit" className="nextBtn mt-3" disabled={!newTenantDateIn || isSubmittingNewTenant} >
                      {isSubmittingNewTenant ? "Saving..." : "Save"}
                    </Button>
                  </Form> </>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" onClick={handleCloseModalReload} >
                  DONE
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <p className='noTenantAlert' >No tenant kindly add one</p>
        </>

        :
        <>
          <div className='d-flex justify-content-between mb-2'>
            <p></p>
            <h2>TENANTS</h2>
            <Button className='btn btn-sm btn-PRIMARY border-0 text-white' onClick={handleOpenModal}>Add Tenant</Button>

            {/* modal for adding a new tenant */}
            <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Add Tenant</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <>
                  <Form onSubmit={handleSubmitTenanat}>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        className="input-field"
                        type="text"
                        name="full_name"
                        value={formDataTenant.full_name}
                        onChange={handleChangeTenant}
                        placeholder={"Tenant Name"}
                        required
                      />
                    </div>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        className="input-field"
                        type="number"
                        name="phone_number"
                        value={formDataTenant.phone_number}
                        onChange={handleChangeTenant}
                        placeholder={"Tenant Phone Number"}
                        required
                      />
                    </div>
                    <div className="tenant-date-label mt-3">Tenant Date In</div>
                    <div className="input-icons">
                      <i className="fa fa-hashtag icon"></i>
                      <input
                        type="date"
                        className="input-field"
                        value={newTenantDateIn || ""}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => setNewTenantDateIn(e.target.value)}
                        required
                      />
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        paddingRight: "20px",
                        float: "right",
                      }}
                    >
                      {digitCount}/10
                    </p>
                    <Button variant="primary" type="submit" className="nextBtn mt-3" disabled={!newTenantDateIn || isSubmittingNewTenant} >
                      {isSubmittingNewTenant ? "Saving..." : "Save"}
                    </Button>
                  </Form> </>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" onClick={handleCloseModalReload} >
                  DONE
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          <Table className='table'>
            <thead className='tableThead'>
              <th>Name</th>
              <th>Phone Number</th>
              <th>Add Tenant To Unit</th>
              <th>Remove Tenant</th>
              <th>Call Tenant</th>
            </thead>
            <tbody>

              {tenantsTable.map((tenant, index) =>
                <tr key={tenant.id}>
                  <td>{tenants[tenant.user].fullName}</td>
                  <td>{tenants[tenant.user].phoneNumber}</td>
                  <td><Button tenantId={tenant.id} className='btn btn-warning border-0 text-white' onClick={() => handleOpenSaveTenant(tenant)}>Add </Button></td>

                  {/* add tenant modal */}
                  <Modal show={showModalSaveTenant} onHide={handleCloseModalSaveTenant}>
                    <Modal.Header closeButton>
                      <Modal.Title>Add Tenant To House</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div className="mb-3">
                        <p className="form-label">
                          Tenant Date In
                        </p>
                        <input
                          type="date"
                          id="tenantDateIn"
                          className="form-control"
                          value={tenantDateIn}
                          max={new Date().toISOString().split("T")[0]} // restrict to today and past only
                          onChange={(e) => setTenantDateIn(e.target.value)}
                        />

                      </div>

                      {tenantDateIn && (
                        <div className="alert alert-warning mt-3">
                          Are you sure you want to add the tenant starting from{" "}
                          <strong>{tenantDateIn}</strong>?
                        </div>
                      )}
                    </Modal.Body>

                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseModalSaveTenant}>
                        Cancel
                      </Button>
                      <Button
                        tenantid={tenant.id}
                        variant="success"
                        onClick={() => handleAddTenanat()}
                        disabled={!tenantDateIn || isSubmittingExistingTenant} // disable until a date is chosen
                      >
                        {isSubmittingExistingTenant ? "Confirming..." : "Confirm"}
                      </Button>
                    </Modal.Footer>
                  </Modal>



                  <td><Button className='btn btn-danger border-0 text-white' onClick={() => handleOpenDeleteTenant(tenant)}>Remove</Button></td>
                  {/* delete tenant */}
                  <Modal show={showModalDeleteTenant} onHide={handleCloseModalDeleteTenant}>
                    <Modal.Header closeButton>
                      <Modal.Title>Delete Tenant.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Do you want to delete this?</Modal.Body>
                    <Modal.Footer>
                      <Button variant="success" onClick={handleCloseModalDeleteTenant}>
                        No
                      </Button>
                      <Button tenantId={tenant.id} variant="danger" onClick={handleDeleteTenanat}>
                        Yes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <td><Button className='btn btn-success border-0 text-white' >Call</Button></td>
                </tr>
              )}
            </tbody>
          </Table>
        </>

      }

    </div>

  )
}

export default AddTenant
